import { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { DataDeletion } from './pages/DataDeletion';
import { ThankYou } from './pages/ThankYou';
import { UseCaseLanding, USE_CASES } from './pages/UseCaseLanding';
import { Chatbot } from './components/Chatbot';
import { FloatingWhatsAppCTA } from './components/FloatingWhatsAppCTA';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      window.setTimeout(() => {
        let targetId = hash.slice(1);
        try {
          targetId = decodeURIComponent(targetId);
        } catch {
          // Keep the raw fragment if an external link contains malformed URI encoding.
        }
        const target = document.getElementById(targetId);
        target?.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  useEffect(() => {
    document.body.className = 'bg-[#faf8ff] text-[#131b2e] tw-ready';
  }, []);

  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-[#faf8ff] font-sans">
        <Routes>
          <Route path="/" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <Home />
              </main>
              <FloatingWhatsAppCTA />
              <Footer />
            </>
          } />

          {/* Redirect routes with scroll */}
          <Route path="/precios" element={<Navigate to="/#pricing" replace />} />
          <Route path="/restaurantes" element={<Navigate to="/#hosteleria" replace />} />
          <Route path="/casos" element={<Navigate to="/#casos" replace />} />
          <Route path="/como-funciona" element={<Navigate to="/#how-it-works" replace />} />
          <Route path="/contacto" element={<Navigate to="/#pricing" replace />} />
          <Route path="/servicios" element={<Navigate to="/#que-hacemos" replace />} />
          <Route path="/comparativa" element={<Navigate to="/#comparativa" replace />} />
          <Route path="/quienes-somos" element={<Navigate to="/#quienes-somos" replace />} />
          <Route path="/sectores" element={<Navigate to="/#hosteleria" replace />} />
          <Route path="/faq" element={<Navigate to="/#faq" replace />} />
          <Route path="/marketing-ia" element={<Navigate to="/#marketing-ia" replace />} />

          <Route path="/clinicas-centros-agenda" element={
            <>
              <Navbar />
              <UseCaseLanding useCase={USE_CASES.clinicas} />
              <FloatingWhatsAppCTA />
              <Footer />
            </>
          } />
          <Route path="/centros-estetica-belleza" element={
            <>
              <Navbar />
              <UseCaseLanding useCase={USE_CASES.estetica} />
              <FloatingWhatsAppCTA />
              <Footer />
            </>
          } />
          <Route path="/agentes-ventas-ia" element={
            <>
              <Navbar />
              <UseCaseLanding useCase={USE_CASES.ventas} />
              <FloatingWhatsAppCTA />
              <Footer />
            </>
          } />
          <Route path="/integraciones-software-ia" element={
            <>
              <Navbar />
              <UseCaseLanding useCase={USE_CASES.integraciones} />
              <FloatingWhatsAppCTA />
              <Footer />
            </>
          } />
          
          <Route path="/privacidad" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <Footer />
            </>
          } />
          <Route path="/privacy" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <Footer />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <Footer />
            </>
          } />
          <Route path="/politica-privacidad" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <Footer />
            </>
          } />
          <Route path="/politica-de-privacidad" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <Footer />
            </>
          } />
          <Route path="/eliminacion-datos" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <DataDeletion />
              </main>
              <Footer />
            </>
          } />
          <Route path="/data-deletion" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <DataDeletion />
              </main>
              <Footer />
            </>
          } />
          <Route path="/gracias" element={<ThankYou />} />
        </Routes>
        
        <Chatbot />
      </div>
    </>
  );
}

export default App;